module.exports = __webpack_public_path__ + "img/audit_ua.3a105293.png";